import { performRequest } from "../performRequest"



export const getLeaveSummary = (params) => {
    return performRequest("get", "/api/ess/leave-summary/",params)
}


export const getLeaveList = (params) => {
    return performRequest("get", "/api/ess/leave/",params)
}


export const exportLeaveListApi = (params) => {
    return performRequest("get", "/api/ess/leave/", { ...params, export: "xlsx" }, true, "blob")
}



export const getHolidayList = (params) => {
    return performRequest("get", "api/ess/public-holiday/",params)
}


export const postLeaveApi = (params) => {
    const company = localStorage.getItem('company') || 1
    params['company'] = company
    return performRequest("post", "/api/ess/leave/",params)
}

export const statusChangeLeaveApi = (params, id) => {
    const company = localStorage.getItem('company') || 1
    params['company'] = company
    return performRequest("patch", `/api/ess/leave/${id}/`,params)
}


export const checkBalanceLeave = (params) => {
    return performRequest("get", `/api/ess/leave/check-balance/`,params)
}




export const getLeaveCalenderApi = (params) => {
    return performRequest("get", "api/ess/leave/year-view/",params)
}



export const getLeaveTeamApi = (params) => {
    return performRequest("get", "api/ess/leave/team-view/",params)
}


export const getAllUsersData = () => {
    return performRequest("get", `api/ess/all-user/`,{type: "role-delegation"})
}




export const getLeaveDetail = (id,params) => {
    return performRequest("get", `/api/ess/leave/${id}/`,params)
}


export const LeavePlannerCalender = (params) => {
    return performRequest("get", "api/ess/leaveplanner/calender/", params)
}


export const createLeavePlanner = (params) => {
    return performRequest("post", "api/ess/leaveplanner/", params)
}

export const updateLeavePlanner = (id, params) => {
    return performRequest("put", `api/ess/leaveplanner/${id}/`, params)
}


export const fetchLeaveByToken = (token) => {
    return performRequest("get", `/api/ess/service/leave-request/`,{token}, false)
}



export const approveLeaveByToken = (params) => {
    return performRequest("post", `api/ess/service/leave-request/`, params, false)
}


export const getLeaveStatistics = (params) => {
    return performRequest("get", `/api/ess/leave-graph-user/`, params)
}